import React from 'react';
import './intro.css';
import woman from '../../assets/woman.png';

const Intro = () => {
  return (
    <section id="home" className="my-2 my-md-4">
        {/* <div className="container-lg my-5">
            <div className="row">
              <div className="col-md-6 my-5">
                  <img className="img-fluid d-none d-md-block my-5" src={woman} alt="girl" />
              </div> 
                <div className="col-md-5 text-center text-md-start mt-5 d-flex align-middle">
                    <div className="display-5 mt-5">Hey! I'm Nivedha Deepak.</div> 
                    <p className="lead mt-5 mb-4">I enjoy bringing ideas to life in the browser. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate, assumenda. Tenetur, aspernatur animi. </p>
                    <a href="#contact" className="btn btn-outline-secondary mb-5">Contact me</a>
                </div>
            </div>
        </div> */}

        <div className="container-lg">
            <div className="row justify-content-center align-items-center">
                <div className="col-md-6 text-start d-none d-md-block my-5 image">
                    <img className="img-fluid" src={woman} alt="woman" />
                </div> 
                
                <div className="col-md-5 text-center text-md-start mt-5 intro">
                    <div className="display-5 mt-5 mt-md-1">Hey! I'm Nivedha Deepak.</div> 
                    <p className="lead text-black my-4">A Front End Web Developer who enjoys designing and building interactive, user-friendly websites. I'm here to bring your interesting ideas and products to life. </p>
                    <a href="#contact" className="btn btn-outline-secondary btn-md fw-bold p-2.5">Contact me</a>
                </div>
                
            </div>
        </div>

    </section>
  )
}

export default Intro